import type { CreateAiSkillDto } from '../../../types/aiSkills'

// Finds the first `open` char and returns the substring up to its matching
// `close`, tracking nesting depth and skipping over quoted-string contents
// (so braces/brackets inside string values, e.g. a JSON example in prose,
// don't prematurely close the match).
function extractBalanced(text: string, open: string, close: string): string | null {
  const start = text.indexOf(open)
  if (start === -1) return null

  let depth = 0
  let inString = false
  let escaped = false

  for (let i = start; i < text.length; i++) {
    const ch = text[i]
    if (inString) {
      if (escaped) escaped = false
      else if (ch === '\\') escaped = true
      else if (ch === '"') inString = false
      continue
    }
    if (ch === '"') inString = true
    else if (ch === open) depth++
    else if (ch === close) {
      depth--
      if (depth === 0) return text.slice(start, i + 1)
    }
  }
  return null
}

export function parseKeyArray(text: string): string[] {
  try {
    const match = extractBalanced(text, '[', ']')
    if (!match) return []
    const parsed = JSON.parse(match)
    if (Array.isArray(parsed) && parsed.every(k => typeof k === 'string')) return parsed
    return []
  } catch {
    return []
  }
}

export function parseSkillDto(text: string, connectorTypeId?: number): CreateAiSkillDto | null {
  try {
    const objText = extractBalanced(text, '{', '}')
    if (!objText) return null
    const nullMatch = text.match(/\bnull\b/)
    const objIndex = text.indexOf(objText)
    if (nullMatch && nullMatch.index! < objIndex) return null
    const parsed = JSON.parse(objText)
    if (!parsed || typeof parsed !== 'object') return null
    if (!parsed.key || !parsed.label || !parsed.content) return null
    return {
      key: String(parsed.key),
      label: String(parsed.label),
      description: String(parsed.description ?? ''),
      content: String(parsed.content),
      connectorTypeId: connectorTypeId ?? null,
      source: 'auto',
    }
  } catch {
    return null
  }
}
